import React from 'react';
import './GradeBanner.scss';
import { useTranslation } from 'react-i18next';
import Banners from '../../../blocks/Banners';
/**
 * Returns a banner if the total time for a grade's configuration exceeds the expected time
 * @param {*} param0 
 * @returns 
 */
const GradeBanner = ({ grade, totalTime, expectedTime }) => {

  const { t } = useTranslation(['common', 'admin_assessment_configuration']);

  if (totalTime > expectedTime) {
    const totalMinutes = Math.round(totalTime / 60);
    const expectedMinutes = Math.round(expectedTime / 60);

    const gradeStrings = {
      0: t('grade_0', {ns: 'common'}),
      1: t('grade_1', {ns: 'common'}),
      2: t('grade_2', {ns: 'common'}),
      3: t('grade_3', {ns: 'common'}),
      4: t('grade_4', {ns: 'common'}),
      5: t('grade_5', {ns: 'common'}),
      6: t('grade_6', {ns: 'common'}),
    }

      return (
        <Banners type="warning">
          <div className='config-grade-banner'>
              <h3>{t(`config_grade_banner_title`, {grade: gradeStrings[grade], ns: 'admin_assessment_configuration'})}</h3>
              <p>{t(`config_grade_banner_message`, {grade: gradeStrings[grade], expectedTime: expectedMinutes, totalTime: totalMinutes, ns: 'admin_assessment_configuration'})}</p>
          </div>
        </Banners>
      );
  }
  return null;
};

export default GradeBanner;